"use strict";
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Package = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var iconTypes_1 = require("../../iconTypes");
var svgIconContainer_1 = require("../../svgIconContainer");
exports.Package = React.forwardRef(function (props, ref) {
    var isLarge = props.size >= iconTypes_1.IconSize.LARGE;
    var pixelGridSize = isLarge ? iconTypes_1.IconSize.LARGE : iconTypes_1.IconSize.STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = { transformOrigin: "center" };
    return (React.createElement(svgIconContainer_1.SVGIconContainer, tslib_1.__assign({ iconName: "package", ref: ref }, props),
        React.createElement("path", { d: isLarge ? "M236.978 393.8728L377.8880000000001 323.4172C391.44 316.6416000000001 400 302.791 400 287.6402V113.542C400 97.186 390.042 82.476 374.856 76.402L195.7668 4.766A40.0116 40.0116 0 0 0 163.0226 6.128L22.1114 76.584C8.56 83.36 0 97.21 0 112.362V286.4602C0 302.8164 9.958 317.5246 25.1444 323.5992L204.234 395.2348A40 40 0 0 0 236.978 393.8728zM200 206.4606V49.542L360 113.542V270.4606L300 246.4606V143.2820000000001L260 127.422V230.4606L200 206.4606z" : "M196 317L298 265C312 259 320 245 320 229V93C320 77 310 61 294 55L156 3C146 -1 134 -1 124 3L22 55C8 61 0 75 0 91V227C0 243 10 259 26 265L164 317C174 321 186 321 196 317zM240 196.14V122L200 106V181.14L160 166.14V45.782L280 91V211.14L240 196.14z", fillRule: "evenodd", transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"), style: style })));
});
exports.Package.defaultProps = {
    size: iconTypes_1.IconSize.STANDARD,
};
exports.Package.displayName = "Blueprint5.Icon.Package";
exports.default = exports.Package;
//# sourceMappingURL=package.js.map